import {Country} from "./country";
import {Document} from "./document";
import {Address} from "./address";
import {strings} from "../strings/strings";

export enum PartyType {
	PERSON = "PERSON",
	ORGANIZATION = "ORGANIZATION"
}

export const PartyTypeMap: Record<string, string> = {
	"PERSON": strings.partyPerson,
	"ORGANIZATION": strings.partyOrganization
};

export enum PersonType {
	PERSON
}

export interface Party {
	partyType: PartyType;
	resident: boolean;
	residentCountry: Country;
	mobileNumber: string;
	email: string;
	registrationDocument: Document;
}

export interface Person extends Party{
	type: PersonType;
	ipn: string;
	surname: string;
	givenName: string;
	middleName: string;
	birthDate: Date;
	livingAddress: Address;
}

export const mapPersonFields = (source: Person, target: Person) => {
	if (source.birthDate !== null) {
		target.birthDate = source.birthDate
	}

	if (source.givenName !== null) {
		target.givenName = source.givenName
	}

	if (source.ipn !== null) {
		target.ipn = source.ipn
	}

	if (source.livingAddress !== null) {
		target.livingAddress = {
			unstructured: source.livingAddress.unstructured
		}
	}

	if (source.middleName !== null) {
		target.middleName = source.middleName
	}

	if (source.surname !== null) {
		target.surname = source.surname
	}

	if (source.type !== null) {
		target.type = source.type
	}

	if (source.email !== null) {
		target.email = source.email
	}

	if (source.partyType !== null) {
		target.partyType = source.partyType
	}

	if (source.mobileNumber !== null) {
		target.mobileNumber = source.mobileNumber
	}

	if (source.registrationDocument !== null) {
		target.registrationDocument = {
			documentType: source.registrationDocument.documentType,
			issueDate: source.registrationDocument.issueDate,
			issueOrganization: source.registrationDocument.issueOrganization,
			number: source.registrationDocument.number,
		}
	}

	if (source.resident !== null) {
		target.resident = source.resident
	}

	if (source.residentCountry !== null) {
		target.residentCountry = source.residentCountry
	}
}